import { useEffect, useState } from "react";

/**
 * Live clock chip for the Navbar showing US Eastern time.
 * Automatically switches between EST and EDT via Intl.DateTimeFormat.
 * At-a-glance reference for the daily server restart (which runs on EST).
 */
export default function ServerTimePill({ className = "", mobile = false }) {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    // Update every 15s — precise enough for "restart timing" without
    // burning render cycles.
    const id = setInterval(() => setNow(new Date()), 15000);
    return () => clearInterval(id);
  }, []);

  // Build "H:MM AM/PM" + short zone label ("EST" / "EDT").
  const timeFmt = new Intl.DateTimeFormat("en-US", {
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
    timeZone: "America/New_York",
  });
  const zoneFmt = new Intl.DateTimeFormat("en-US", {
    timeZone: "America/New_York",
    timeZoneName: "short",
  });
  const time = timeFmt.format(now);
  // zoneFmt emits e.g. "2/28/2026, EST"; grab the last token.
  const parts = zoneFmt.formatToParts(now);
  const zone = parts.find((p) => p.type === "timeZoneName")?.value || "ET";

  return (
    <div
      data-testid="server-time-pill"
      title={`Server time (${zone}). Daily restart references this clock.`}
      className={`${mobile ? "inline-flex" : "hidden lg:inline-flex"} items-center gap-2 border border-[#283524] bg-[#0D110C]/60 px-3 py-1.5 font-mono-ui text-[10px] uppercase tracking-[0.25em] text-[#8D9A87] whitespace-nowrap ${className}`}
    >
      <span
        className="w-1.5 h-1.5 rounded-full bg-[#C0A875] animate-pulse"
        aria-hidden="true"
      />
      <span className="text-[#C0A875]">{time}</span>
      <span className="text-[#5C6B51]">{zone}</span>
    </div>
  );
}
